import styled from 'styled-components';

export const IdleRecommendationHeaderTitleWrapperBox = styled.div`
    ${({theme}) => theme.font.presets.body};
    text-align: center;
`;
